import { render } from "./AdminMenu.vue?vue&type=template&id=367ece98&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"

import "./AdminMenu.vue?vue&type=style&index=0&id=367ece98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367ece98"]])

export default __exports__